<template lang='pug'>
  div
    v-card-title
      h3.text-h5.font-weight-light Notifications ({{count}})
      v-tooltip(right)
        template(v-slot:activator='{on}')
          v-btn(v-on='on' @click.stop='openCreate' icon color='primary')
            v-icon add
        span Add Notification
    bionic-metrics-notifications-table(:notifications='value' @edit='openEdit' @remove='removeNotification' @create='openCreate')
    bionic-metrics-edit-notification(ref='notificationDialog' @edit='editNotification' @add='addNotification' :dashboard='dashboard')
</template>

<script>
import BionicMetricsEditNotification from '@/components/EditNotification';
import BionicMetricsNotificationsTable from '@/components/NotificationsTable';

export default {
  name: 'BionicMetricsNotifications',
  components: {BionicMetricsEditNotification, BionicMetricsNotificationsTable},
  props: {
    dashboard: {
      type: Object
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    count() {
      return this.value.length;
    },
    noData() {
      return !this.value.length;
    },
    createOrEdit() {
      return this.creating ? 'Create' : 'Edit';
    },
    createOrSave() {
      return this.creating ? 'Create' : 'Save';
    },
    allSelected() {
      if (!this.active || !this.active.testSuites) return false;
      for (const ts of this.active.testSuites) {
        if (ts.guid === 'all') return true;
      }
      return false;
    },
    availableSuites() {
      if (!this.dashboard || !this.dashboard.testSuites) return [];
      const avail = this.dashboard.testSuites.map((ts) => ({
        name: ts.name,
        description: ts.description,
        guid: ts.guid,
        testSuite: ts._id,
        disabled: this.allSelected
      }));
      return [{name: 'All', description: 'Run all suites', guid: 'all'}].concat(avail);
    }
  },
  methods: {
    openCreate() {
      this.$refs.notificationDialog.add();
    },
    openEdit(index) {
      const notification = this.value[index];
      this.$refs.notificationDialog.edit({...notification}, index);
    },
    addNotification(notification) {
      this.$emit('input', [...this.value, notification]);
    },
    editNotification(notification, index) {
      const edited = this.value.map((it, i) => {
        if (i === index) return notification;
        return it;
      });
      this.$emit('input', edited);
    },
    async removeNotification(index) {
      const removed = this.value.filter((it, i) => i !== index);
      this.$emit('input', removed);
    }
  }
};
</script>

<style scoped>

</style>
